import { defineRecipe } from '@chakra-ui/react';

export const badgeRecipe = defineRecipe({
    base: {
        textTransform: 'none',
        textAlign: 'center',
        borderRadius: 'md',
        fontWeight: 'bold',
    },
    variants: {
        variant: {
            subtle: {
                color: 'gray.950',
            },
            outline: {
                '--shadow-color': 'colors.colorPalette.400',
            },
            chip: {
                h: 8,
                bg: 'white',
                color: 'secondary.600',
                fontWeight: 'normal',
            },
        },
        size: {
            sm: {
                fontSize: 'xs',
                py: 1,
                px: 1.5,
            },
            md: {
                fontSize: 'sm',
                py: 1,
                px: 2,
                borderRadius: 'md',
            },
            lg: {
                py: 1.5,
                px: 2,
                borderRadius: 'md',
            },
        },
    },
    defaultVariants: {
        size: 'md',
    },
});
